import React from 'react';
import { Field } from 'react-final-form';
import { FormIfOperator } from 'Shared/constants/types';

function getCondition(operator, value, currentValue) {
  switch (operator) {
    case FormIfOperator.include:
      return value.includes(currentValue);
    case FormIfOperator.equal:
      return value === currentValue;
    case FormIfOperator.notInclude:
      return !value.includes(currentValue);
    case FormIfOperator.notEqual:
      return value !== currentValue;
    case FormIfOperator.notEmpty:
      return currentValue && Array.isArray(currentValue) && currentValue.length;
    default:
      throw new Error(
        'This operator is not exist, you must use onde of "include", "equal", "notInclude" or "notEqual"'
      );
  }
}

type PropType = {
  children;
  fieldName: string;
  operator: FormIfOperator;
  value?: string | number | boolean | Array<string> | Array<number> | Array<boolean> | null | undefined;
};

export default function FormIf({ children, fieldName, operator, value }: PropType) {
  return (
    <Field name={fieldName}>
      {({ input: { value: currentValue } }) => (getCondition(operator, value, currentValue) ? children : <div />)}
    </Field>
  );
}
